import { Controller } from "@hotwired/stimulus"
import { enter, leave, toggle } from "el-transition"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    const toggle = this.element.querySelector('[data-action*="reveal#toggle"]')
    if (toggle && toggle.checked) {
      this.itemTargets.forEach((item) => item.classList.remove("hidden"))
    }
  }

  toggle() {
    this.itemTargets.forEach((item) => {
      toggle(item)
    })
  }

  show() {
    this.itemTargets.forEach((item) => {
      enter(item)
    })
  }

  hide() {
    this.itemTargets.forEach((item) => {
      leave(item)
    })
  }
}